import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";
import { bloodTypeOptions } from "validations/patientSchemas";

function MedicationInformationSection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreatePatientForm>();

  return (
    <Box className="space-y-6 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Medication Information
      </Typography>

      <Box className="grid grid-cols-3 gap-4">
        {/* First Row */}
        <Controller
          name="bloodType"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth error={!!errors.bloodType}>
              <InputLabel id="blood-type-label">Blood Type</InputLabel>
              <Select
                labelId="blood-type-label"
                id="blood-type"
                label="Blood Type"
                {...field}
                value={field.value || ""}
              >
                {bloodTypeOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
              {errors.bloodType && (
                <FormHelperText>
                  {errors.bloodType.message as string}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />

        <Controller
          name="height"
          control={control}
          render={({ field }) => (
            <TextField
              id="height"
              label="Height (cm)"
              variant="outlined"
              type="number"
              fullWidth
              error={!!errors.height}
              helperText={errors.height?.message as string}
              {...field}
              onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : "";
                field.onChange(value);
              }}
            />
          )}
        />

        <Controller
          name="weight"
          control={control}
          render={({ field }) => (
            <TextField
              id="weight"
              label="Weight (kg)"
              variant="outlined"
              type="number"
              fullWidth
              error={!!errors.weight}
              helperText={errors.weight?.message as string}
              {...field}
              onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : "";
                field.onChange(value);
              }}
            />
          )}
        />

        {/* Second Row - Text areas spanning multiple columns */}
        <Controller
          name="allergies"
          control={control}
          render={({ field }) => (
            <TextField
              id="allergies"
              label="Allergies"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors.allergies}
              helperText={errors.allergies?.message as string}
              {...field}
            />
          )}
        />

        <Controller
          name="currentMedicine"
          control={control}
          render={({ field }) => (
            <TextField
              id="current-medicine"
              label="Current Medicine"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors.currentMedicine}
              helperText={errors.currentMedicine?.message as string}
              {...field}
            />
          )}
        />

        <Controller
          name="chronicConditions"
          control={control}
          render={({ field }) => (
            <TextField
              id="chronic-conditions"
              label="Chronic Conditions"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors.chronicConditions}
              helperText={errors.chronicConditions?.message as string}
              {...field}
            />
          )}
        />
      </Box>
    </Box>
  );
}

export default MedicationInformationSection;
